import swal from "sweetalert2"
<template>
<span>
  <button
    type="button"
    :class="btnClass === '' ? 'btn btn-info btn-flat btn-block' : btnClass"
    @click="$refs.photosEvent.click()"
    title="Enviar Fotos"
  >
    <i class="ti-camera"></i> {{btnClass === '' ? 'Enviar Fotos' : ''}}
  </button>

  <input
    style="display: none;"
    @change="getFiles"
    type="file"
    ref="photosEvent"
    accept="image/*"
    multiple
    hidden
  />

  <dialog-upload-photos-event
    :event-id="event._id"
    :show="dialog.show"
    :files="dialog.files"
    @upload-photos="show = false"
  ></dialog-upload-photos-event>

  <canvas id="canvasPlace" hidden></canvas>
</span>
</template>

<script>
  import swal from 'sweetalert2'
  import {filesService} from 'src/services'
  import DialogUploadPhotosEvent from './DialogUploadPhotosEvent'

  export default {
    name: 'BtnUploadPhotosEvent',

    components: {
      DialogUploadPhotosEvent
    },

    props: {
      btnClass: {
        default: ''
      },
      event: {
        required: false
      }
    },

    data () {
      return {
        dialog: {
          show: false,
          files: []
        }
      }
    },

    methods: {
      openDialogPhotosEvent () {
        this.dialog.show = true
      },

      async getFiles (event) {
        swal({
          title: 'Informação',
          text: 'Estamos enviado as fotos para o servidor, por favor, aguarde.',
          type: 'info',
          showConfirmButton: false,
          allowOutsideClick: false,
          onOpen: async () => {
            swal.showLoading()
            await this.handleFile(event)
            swal.hideLoading()
            swal.close()
          }
        })
      },

      async handleFile (event) {
        console.log(event)
        try {
          this.dialog.files = await filesService.handleImage(event)
          console.log('imagens', this.dialog.files)
          this.openDialogPhotosEvent()
        } catch (e) {
          console.log('err', e)
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Events/UploadPhotos/BtnUploadPhotosEvent.vue